<script>
import { defineComponent } from 'vue'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import { ComboboxOption } from '@headlessui/vue'

export default defineComponent({
  name: 'HomeSearchResultListItem',
  components: { ComboboxOption, ChevronRightIcon },
  props: {
    searchResultItem: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<template>
  <ComboboxOption v-if="searchResultItem.object_type_short === 'FundraiserPage'" v-slot="{ active }" as="template" :value="searchResultItem">
    <div :class="['group flex flex-wrap cursor-default select-none items-center py-2 pl-3 pr-1 gap-2', active && 'bg-blue-600 text-white outline-none']">
      <img v-if="searchResultItem.cached && searchResultItem.cached.owner_avatar_url_small" :src="searchResultItem.cached.owner_avatar_url_small" :alt="searchResultItem.cached.owner_name" class="size-6 rounded-full">
      <span v-else class="inline-flex min-w-6 size-6 items-center justify-center rounded-full bg-gray-100">
        <span v-if="searchResultItem.cached && searchResultItem.cached.owner_initials" class="text-xxs font-sans leading-none text-gray-400">{{ searchResultItem.cached.owner_initials }} </span>
      </span>

      <h6>{{ searchResultItem.cached && searchResultItem.cached.owner_name ? searchResultItem.cached.owner_name : null }}</h6>
      <span class="flex-auto truncate">{{ searchResultItem.title }}</span>
    </div>
  </ComboboxOption>
  <ComboboxOption v-else-if="searchResultItem.object_type_short === 'Fundraiser'" v-slot="{ active }" :value="searchResultItem" as="template">
    <div :class="['group flex flex-wrap cursor-default select-none items-center py-2 pl-3 pr-1 gap-2', active && 'bg-blue-600 text-white outline-none']">
      <img :src="searchResultItem.cover_image_url_small" alt="" class="size-6 flex-none rounded-full">
      <h6 class="flex-auto truncate">
        {{ searchResultItem.title }}
      </h6>
      <ChevronRightIcon v-if="active" class="size-5 flex-none text-white" aria-hidden="true" />
    </div>
  </ComboboxOption>
  <ComboboxOption v-else-if="searchResultItem.object_type_short === 'Team'" v-slot="{ active }" as="template" :value="searchResultItem">
    <div :class="['group flex flex-wrap cursor-default select-none items-center py-2 pl-3 pr-1 gap-2', active && 'bg-blue-600 text-white outline-none']">
      <img v-if="searchResultItem.cached && searchResultItem.cached.cover_image_url_small" :src="searchResultItem.cached.cover_image_url_small" alt="" class="size-6 flex-none rounded-full">
      <h6>{{ searchResultItem.name }} {{ searchResultItem.cached && searchResultItem.cached.fundraiser_title? ': ' + searchResultItem.cached.fundraiser_title:null }} </h6>
      <span class="flex-auto truncate">{{ searchResultItem.title }}</span>
    </div>
  </ComboboxOption>
</template>

<style scoped>

</style>
